import { Routes, Route } from "react-router-dom";
import { Component, Fragment } from "react";
import axios from "axios";

import ForgetPasswordPage from "../pages/ForgetPasswordPage";
import HomePage from "../pages/HomePage.jsx";
import NotificationPage from "../pages/NotificationPage";
import UserLoginPage from "../pages/UserLoginPage.jsx";

import ContactPage from "../pages/ContactPage";
import PrivacyPage from "../pages/PrivacyPage";
import ProfilePage from "../pages/ProfilePage";
import PurchasePage from "../pages/PurchasePage";
import RefundPage from "../pages/RefundPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import RegisterPage from "../pages/RegisterPage";
import ProductDetailsPage from "../pages/ProductDetailsPage.jsx";
import AboutPage from "../pages/AboutPage";

import WebsiteDevelopmentService from "../pages/WebsiteDevelopmentService";
import DomainHostingService from "../pages/DomainHostingService";
import CctvCamera from "../pages/CctvCamera";
import ComputerRepairPage from "../pages/ComputerRepairPage";
import ComputerNetworkPage from "../pages/ComputerNetworkPage";

import PospressoPage from "../pages/PospressoPage";
import PospressoPluspage from "../pages/PospressoPluspage";
import CatHomisPage from "../pages/CatHomisPage";
import TradeHubPage from "../pages/TradeHubPage";

import LiveDemoPage from "../pages/LiveDemoPage";
import ParkingPage from "../pages/ParkingPage";
import PospressoLivePage from "../pages/PospressoLivePage";
import PospressoPlusLivePage from "../pages/PospressoPlusLivePage";
import CatHomisLivePage from "../pages/CatHomisLivePage";
import TradeHubLivePage from "../pages/TradeHubLivePage";

import NewsletterSubscribePage from "../pages/NewsletterSubscribePage";
import OurProductsPage from "../pages/OurProductsPage";
import ServicePage from "../pages/ServicePage";
import OurClients from "../pages/OurClients";
import RequestForQuotePage from "../pages/RequestForQuotePage";
import VideosPage from "../pages/VideosPage";
import JobsPage from "../pages/JobsPage";
import NavMenuDesktop from "../components/common/NavMenuDesktop";
import Dashboard from "../components/common/Dashboard";
import AppURL from "../api/AppURL";


import ProtectedRoute from '../components/common/ProtectedRoute';




class AppRoute extends Component {

  

  constructor() {
    super();
    this.state = {
      user: {}
    };
  }

  componentDidMount() {


    
      axios.get(AppURL.UserData).then((response) => { 
        this.setUser(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  setUser = (user) => {
    this.setState({ user: user });
  };

  render() {
    return (
      <Fragment>
       <NavMenuDesktop
  user={this.state.user}
  setUser={this.setUser}
/> 



        <Routes>
          <Route path="/" element={<HomePage />} />
         
        
<Route  path="/login"  element={    <UserLoginPage   user={this.state.user} setUser={this.setUser}    />
  }
/>

<Route  path="/register"  element={  <RegisterPage    user={this.state.user}   setUser={this.setUser}  />
  }
/>

<Route  path="/profile"  element={    <ProfilePage   user={this.state.user}   setUser={this.setUser} />
  }
/>
        
        
          <Route path="/forget" element={<ForgetPasswordPage />} />
          <Route path="/reset/:id" element={<ResetPasswordPage />} />

          <Route path="/jobs" element={<JobsPage />} />

          <Route path="/contact" element={<ContactPage />} />
          <Route path="/purchase" element={<PurchasePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/about" element={<AboutPage />} />

          <Route path="/parkease" element={<ProductDetailsPage />} />
          <Route path="/pospresso" element={<PospressoPage />} />
          <Route path="/pospresso_plus" element={<PospressoPluspage />} />
          <Route path="/cat_homis" element={<CatHomisPage />} />
          <Route path="/tradehub" element={<TradeHubPage />} />

          <Route path="/products" element={<OurProductsPage />} />

          <Route path="/notification" element={<NotificationPage />} />

          <Route path="/website-development" element={<WebsiteDevelopmentService />} />
          <Route path="/domainhosting" element={<DomainHostingService />} />
          <Route path="/cctvcameras" element={<CctvCamera />} />
          <Route path="/computerrepair" element={<ComputerRepairPage />} />
          <Route path="/networking" element={<ComputerNetworkPage />} />

          <Route path="/services" element={<ServicePage />} />
          <Route path="/ourclients" element={<OurClients />} />

          <Route path="/requestquote" element={<RequestForQuotePage />} />

          {/* LIVE DEMO */}
          <Route path="/livedemo" element={<LiveDemoPage />} />
          <Route path="/parking" element={<ParkingPage />} />
          <Route path="/pospressolive" element={<PospressoLivePage />} />
          <Route path="/PospressoPlusLive" element={<PospressoPlusLivePage />} />
          <Route path="/cathomisLive" element={<CatHomisLivePage />} />
          <Route path="/newlettersubscribe" element={<NewsletterSubscribePage />} />
          <Route path="/tradehublive" element={<TradeHubLivePage />} />

          <Route path="/videos" element={<VideosPage />} />

       
      <Route    path="/dashboard"    element={<ProtectedRoute>  <Dashboard /> </ProtectedRoute>  }
/>
      </Routes>
      </Fragment>
    );
  }
}

export default AppRoute;